import React from 'react';
import PropTypes from 'prop-types';

const Button = ({children, className, disabled=false, htmlId, onClick, name, title, type="button", ...props}) => {
    return(
        <button
            className={className}
            disabled={disabled}
            id={htmlId}
            onClick={onClick}
            name={name}
            title={title}
            type={type}
            {...props}>
            {children}
        </button>
    );
};

Button.propTypes = {
    //Child component.
    children: PropTypes.node,
    //Class which will be applied to button component.
    className: PropTypes.string,
    //Is button disabled.
    disabled: PropTypes.bool,
    //HTML id attribute.
    htmlId: PropTypes.string,
    //Funtion triggered on click.
    onClick: PropTypes.func,
    //Input name. Recommend setting this to match object's property so a single change handler can be used.
    name:PropTypes.string,
    //Tool tip text while button is hover
    title: PropTypes.string,
    //Button type
    type: PropTypes.string
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/base/Button/Button.js